module.exports = __webpack_public_path__ + "img/191761991491375_image.jpg";